<template>
    <div class="container">
        <content-header title="Регистрационные документы поликлиники"/>
        <p><strong>Учредителем Учреждения является Российская Федерация. Полномочия Учредителя Учреждения от имени
            Российской Федерации осуществляет Управление делами Президента Российской Федерации — федеральный орган
            исполнительной власти.</strong></p>
        <p><a href="/static/files/staticContent/Устава-2017-оригинал.pdf" target="_blank" class="link">Устав (утв.
            Приказом Управления делами Президента Российской Федерации от 23.10.2017г. № 442)</a></p>
        <div class="inv-divider"></div>
        <div class="width-100">
            <span><span></span></span>
            <h4>ЛИЦЕНЗИЯ НА ОСУЩЕСТВЛЕНИЕ МЕДИЦИНСКОЙ ДЕЯТЕЛЬНОСТИ</h4>
            <span><span></span></span>
        </div>
        <div class="inv-divider"></div>
        <div class="flex">
            <img
                @click="selectedImage = img1_1" :src="img1_1"
                height="198" width="140"
            />
            <img
                @click="selectedImage = img1_2" :src="img1_2"
                height="198" width="140"
            />
            <img
                @click="selectedImage = img1_3" :src="img1_3"
                height="198" width="140"
            />
            <img
                @click="selectedImage = img1_4" :src="img1_4"
                height="198" width="140"
            />
            <img
                @click="selectedImage = img1_5" :src="img1_5"
                height="198" width="140"
            />
        </div>
        <div class="inv-divider"></div>
        <div class="width-100">
            <span><span></span></span>
            <h4>выписка из реестра лицензий на осуществление медицинской деятельности</h4>
            <span><span></span></span>
        </div>
        <div class="inv-divider"></div>
        <div class="flex">
            <img
                @click="selectedImage = img2_1" :src="img2_1"
                height="340" width="240"
            />
            <img
                @click="selectedImage = img2_2" :src="img2_2"
                height="340" width="240"
            />
            <img
                @click="selectedImage = img2_3" :src="img2_3"
                height="340" width="240"
            />
            <img
                @click="selectedImage = img2_4" :src="img2_4"
                height="340" width="240"
            />
        </div>
        <div class="inv-divider"></div>
        <div class="width-100">
            <span><span></span></span>
            <h4>выписка из реестра лицензий на осуществление фармацевтической деятельности</h4>
            <span><span></span></span>
        </div>
        <div class="inv-divider"></div>
        <div class="flex">
            <img
                @click="selectedImage = img3_1" :src="img3_1"
                height="340" width="240"
            />
            <img
                @click="selectedImage = img3_2" :src="img3_2"
                height="340" width="240"
            />
        </div>
        <div class="inv-divider"></div>
        <div class="width-100">
            <span><span></span></span>
            <h4>выписка из реестра лицензий на деятельность по обороту наркотических средств,психотропных веществ и их
                прекурсоров, культивированию наркосодержащих растений</h4>
            <span><span></span></span>
        </div>
        <div class="inv-divider"></div>
        <div class="flex">
            <img
                @click="selectedImage = img4_1" :src="img4_1"
                height="340" width="240"
            />
            <img
                @click="selectedImage = img4_2" :src="img4_2"
                height="340" width="240"
            />
        </div>
        <div class="inv-divider"></div>
        <div class="width-100">
            <span><span></span></span>
            <h4>СВИДЕТЕЛЬСТВО МОСКОВСКОЙ РЕГИСТРАЦИОННОЙ ПАЛАТЫ</h4>
            <span><span></span></span>
        </div>
        <div class="inv-divider"></div>
        <div class="flex">
            <img
                @click="selectedImage = img5_1" :src="img5_1"
                height="337" width="480"
            />
            <img
                @click="selectedImage = img5_2" :src="img5_2"
                height="337" width="480"
            />
        </div>
        <div class="inv-divider"></div>
        <div class="width-100">
            <span><span></span></span>
            <h4>СВИДЕТЕЛЬСТВО О ВНЕСЕНИИ ЗАПИСИ В ЕГРЮЛ</h4>
            <span><span></span></span>
        </div>
        <div class="inv-divider"></div>
        <div class="flex">
            <img
                @click="selectedImage = img6_1" :src="img6_1"
                height="600" width="420"
            />
        </div>
        <div class="inv-divider"></div>
        <div class="width-100">
            <span><span></span></span>
            <h4>ВЫПИСКА ИЗ РЕЕСТРА ЛИЦЕНЗИЙ ПО СОСТОЯНИЮ НА 16-08 01.08.2022г</h4>
            <span><span></span></span>
        </div>
        <div class="inv-divider"></div>
        <div class="flex">
            <img
                @click="selectedImage = img7_1" :src="img7_1"
                height="438" width="310"
            />
            <img
                @click="selectedImage = img7_2" :src="img7_2"
                height="438" width="310"
            />
            <img
                @click="selectedImage = img7_3" :src="img7_3"
                height="438" width="310"
            />
        </div>
        <div class="inv-divider"></div>
        <div class="width-100">
            <span><span></span></span>
            <h4>ЛИЦЕНЗИЯ НА ФАРМАЦЕВТИЧЕСКУЮ ДЕЯТЕЛЬНОСТЬ</h4>
            <span><span></span></span>
        </div>
        <div class="inv-divider"></div>
        <div class="flex">
            <img
                @click="selectedImage = img8_1" :src="img8_1"
                height="438" width="310"
            />
            <img
                @click="selectedImage = img8_2" :src="img8_2"
                height="438" width="310"
            />
            <img
                @click="selectedImage = img8_3" :src="img8_3"
                height="438" width="310"
            />
        </div>
        <div class="selected-image-wrapper" v-if="selectedImage" @click="selectedImage = null">
            <div class="selected-image">
                <img :src="selectedImage" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";
// img 1
import img1_1 from '../../assets/images/staticPages/Лицензия-на-меддеятельность-21.02.2018-1.jpg'
import img1_2 from '../../assets/images/staticPages/Лицензия-на-меддеятельность-21.02.2018-2.jpg'
import img1_3 from '../../assets/images/staticPages/Лицензия-на-меддеятельность-21.02.2018-3.jpg'
import img1_4 from '../../assets/images/staticPages/Лицензия-на-меддеятельность-21.02.2018-4.jpg'
import img1_5 from '../../assets/images/staticPages/Лицензия-на-меддеятельность-21.02.2018-5.jpg'
// img 2
import img2_1 from '../../assets/images/staticPages/Выписка-из-реестра-лицензий-на-медицинскую-деятельность_Page_1.jpg'
import img2_2 from '../../assets/images/staticPages/Выписка-из-реестра-лицензий-на-медицинскую-деятельность_Page_2.jpg'
import img2_3 from '../../assets/images/staticPages/Выписка-из-реестра-лицензий-на-медицинскую-деятельность_Page_3.jpg'
import img2_4 from '../../assets/images/staticPages/Выписка-из-реестра-лицензий-на-медицинскую-деятельность_Page_4.jpg'
// img 3
import img3_1 from '../../assets/images/staticPages/Выписка-из-реестра-на-фармацевтическую-деятельность_Page_1.jpg'
import img3_2 from '../../assets/images/staticPages/Выписка-из-реестра-на-фармацевтическую-деятельность_Page_2.jpg'
// img 4
import img4_1 from '../../assets/images/staticPages/Выписка-из-реестра-на-деятельность-по-обороту-НС-и-ПВ_Page_1.jpg'
import img4_2 from '../../assets/images/staticPages/Выписка-из-реестра-на-деятельность-по-обороту-НС-и-ПВ_Page_2.jpg'
// img 5
import img5_1 from '../../assets/images/staticPages/reg1.jpg'
import img5_2 from '../../assets/images/staticPages/reg2.jpg'
// img 6
import img6_1 from '../../assets/images/staticPages/fns-420x600.jpg'
// img 7
import img7_1
    from '../../assets/images/staticPages/Выписка-из-реестра-лицензий-по-состоянию-на-16-08-01.08.2022г._Page_1.jpg'
import img7_2
    from '../../assets/images/staticPages/Выписка-из-реестра-лицензий-по-состоянию-на-16-08-01.08.2022г._Page_2.jpg'
import img7_3
    from '../../assets/images/staticPages/Выписка-из-реестра-лицензий-по-состоянию-на-16-08-01.08.2022г._Page_3.jpg'
// img 8
import img8_1 from '../../assets/images/staticPages/Лицензния-на-фарм.-деятельность-15.08.2016_Page_1_Image_0001.jpg'
import img8_2 from '../../assets/images/staticPages/Лицензния-на-фарм.-деятельность-15.08.2016_Page_2_Image_0001.jpg'
import img8_3 from '../../assets/images/staticPages/Лицензния-на-фарм.-деятельность-15.08.2016_Page_3_Image_0001.jpg'

export default {
    name: "registrationDocuments",
    components: {
        ContentHeader
    },
    data() {
        return {
            selectedImage: null,
            img1_1,
            img1_2,
            img1_3,
            img1_4,
            img1_5,
            img2_1,
            img2_2,
            img2_3,
            img2_4,
            img3_1,
            img3_2,
            img4_1,
            img4_2,
            img5_1,
            img5_2,
            img6_1,
            img7_1,
            img7_2,
            img7_3,
            img8_1,
            img8_2,
            img8_3
        }
    }
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.divider.absolute {
    position: absolute;
    margin: 6px 0 0 0;
}

.flex {
    display: flex;
    flex-wrap: wrap;
}

.flex img {
    max-width: 100%;
    height: auto;
    margin: 0 0 15px;
    cursor: pointer;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

.width-100 {
    width: 100%;
    display: flex;
    align-items: center;
}

.width-100 > span {
    height: 1px;
    position: relative;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    min-width: 10%;
}

.width-100 > span > span {
    border-color: #ebebeb;
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
}

h4 {
    font-weight: normal;
    color: #000;
    padding: 0 10px;
    background-color: #f5f5f5;
    width: fit-content;
    margin: auto;
    max-width: 800px;
    text-align: center;
    text-transform: uppercase;
}

.selected-image-wrapper {
    cursor: pointer;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    background: rgba(51, 51, 51, 0.3);
    overflow: hidden;
}

.selected-image-wrapper .selected-image {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: baseline;
    padding: 20px;
    overflow: auto;
}

.selected-image-wrapper .selected-image img {
    margin: 0 auto;
    cursor: pointer;
}
</style>
